import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import translationKeys from 'translations/translationKeys';

const Loading = ({ hasText }) => {
  const { msg22 } = translationKeys;
  const { t } = useTranslation();
  return (
    <div
      className="loading"
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'inherit',
        color: 'inherit',
        padding: '10px',
        gap: '4px',
      }}
    >
      <span className="spinner-border spinner-border-sm" />
      { hasText ? (' ') : null }
      { hasText ? (t(msg22)) : null}
    </div>
  );
};

Loading.propTypes = {
  hasText: PropTypes.bool,
};

Loading.defaultProps = {
  hasText: true,
};

export default Loading;
